var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"absolute z-10 w-full h-full flex items-center justify-center",class:_vm.textColor + ' ' + _vm.bgColor},[_c('loading',{attrs:{"label":_vm.label,"text-color":"textColor","size":_vm.size}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }